/** @import PdpProduct from "./pdp-product" */
const { ShadowElement } = await importMod("shadow-mixin");

export default class OptionThemeMarquee extends ShadowElement {
	connectedCallback() {
		super.connectedCallback();
		const pdpProduct = /** @type {PdpProduct} */ (
			this.shadow.querySelector("pdp-product")
		);
		const variantMetafieldData = /** @type {HTMLElement} */ (
			this.shadow.getElementById("variant-metafields-json")
		);
		const variantMetafields = JSON.parse(
			variantMetafieldData.textContent || "{}"
		);
		const metafieldKey = variantMetafieldData.dataset.metafield || "";
		pdpProduct.onSelectedVariant = (e) => {
			const { variant } = e.detail;
			if (!variant) return;
			const colors = variantMetafields[variant.id]?.[metafieldKey];
			if (!Array.isArray(colors)) return;
			this.style.setProperty("--_bg-color", colors[0]);
		};
	}
}

customElements.define("option-theme-marquee", OptionThemeMarquee);
